import { Box, Unstable_TrapFocus, useTheme } from '@mui/material';
import {
  IconButton,
  Tooltip,
} from '@forethought-technologies/forethought-elements';
import { IconX } from '@tabler/icons-react';
import { useAppDispatch, useAppSelector } from 'hooks';
import { selectImageViewer, selectIsViewingImage } from 'reducers/main';
import { clearImageViewer } from 'actions/main';
import { postMessage } from 'utils/postMessage';

const ImageViewer = () => {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const imageViewer = useAppSelector(selectImageViewer);
  const isViewingImage = useAppSelector(selectIsViewingImage);

  if (!isViewingImage) {
    return null;
  }

  const closeImageViewer = () => {
    postMessage({
      event: 'forethoughtWidgetViewImage',
      open: false,
    });
    dispatch(clearImageViewer());
  };

  return (
    <Unstable_TrapFocus open={isViewingImage}>
      <Box
        onClick={closeImageViewer}
        sx={{
          alignItems: 'center',
          backgroundColor: '#0e0e0e',
          bottom: 0,
          display: 'flex',
          justifyContent: 'center',
          left: 0,
          margin: 0,
          padding: 0,
          position: 'fixed',
          top: 0,
          width: '100%',
          zIndex: 2147483647,
        }}
        tabIndex={-1}
      >
        <Box
          sx={{
            backgroundColor: '#0e0e0e',
            color: theme.palette.colors.white,
            position: 'absolute',
            right: '10px',
            top: '10px',
          }}
        >
          <Tooltip tooltipContent='Close image'>
            <IconButton
              aria-label='Close image preview'
              onClick={closeImageViewer}
              variant='ghost'
            >
              <IconX color={theme.palette.colors.white} size={20} />
            </IconButton>
          </Tooltip>
        </Box>
        <Box
          alt={imageViewer.alt}
          component='img'
          onClick={e => {
            e.stopPropagation();
          }}
          src={imageViewer.src}
          sx={{
            display: 'block',
            maxHeight: {
              md: '90%',
              xs: '100%',
            },
            maxWidth: {
              md: '90%',
              xs: '100%',
            },
          }}
        />
      </Box>
    </Unstable_TrapFocus>
  );
};

export default ImageViewer;
